import { render, staticRenderFns } from "./FadeLoader.vue?vue&type=template&id=6a88e460"
import script from "./FadeLoader.vue?vue&type=script&lang=js"
export * from "./FadeLoader.vue?vue&type=script&lang=js"
import style0 from "./FadeLoader.vue?vue&type=style&index=0&id=6a88e460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports